module.exports = __webpack_public_path__ + "img/4db10ec.webp";